import { ScrollTrigger } from "gsap/ScrollTrigger";
import utils from '../utils';
let { isTouchDevice, onSwipe, Wheel, isMobile, onTouchMove } = utils;

export default function Snap({ element, goToPoint, hasPin, trigger, transitionTo, forceStart, forceEnd, onStart, mobileOffset, stickOnInit }) {
  this.element = element;
  this.goToPoint = goToPoint;
  this.onStart = onStart;
  this.trigger = trigger;
  this.transitionTo = transitionTo;
  this.forceStart = forceStart;
  this.forceEnd = forceEnd;
  this.offset = mobileOffset && isMobile ? mobileOffset : 0;
  let points = this.element.querySelectorAll("[data-snap-point]");
  let currentPosition = points[0].offsetTop;
  this.stickOnInit = stickOnInit;

  let isScrolling = false;
  let isStick = this.stickOnInit ? true : false;
  let counter = 0;
  // let currentPosition = 0;

  this.init = () => {
    // console.log(123);
    initStick();
    initSnap();

    $('.hero_btn').click(function(e){
      e.preventDefault();
      onScrollEnd( 'down' );
    } );
  }

  const initStick = () => {
    let pin = !hasPin ? this.element.querySelector("[data-snap-animation]") : false;

    const animationTrigger = ScrollTrigger.create({
      scroller: "[data-scroll-container]",
      trigger: this.trigger || this.element,
      scrub: 1,
      start: (this.forceStart ? "top-=200" : "top") + " top",
      end: "bottom bottom",
      onEnter: (self) => {
        console.log('entered');
        lscroll.stop();
        if(this.forceStart) {
          isStick = true;
          // setTimeout(() => {
            onScrollEnd("down");
          // }, 0)
        }
        setTimeout(() => {
          isStick = true;
        }, 300);
      },
      onLeave: (self) => {
        console.log('leave', this.element)
      },
      onEnterBack: (self) => {
        console.log('enteredBack')
        lscroll.stop();
        if(this.forceEnd) {
          console.log('forceEnd')
          console.log('forceEnd', isScrolling)
          isStick = true;
          onScrollEnd("up");
        }
        setTimeout(() => {
          isStick = true;
        }, 300);
      },
      // onUpdate: self => console.log("progress", self.progress),
      pin: pin,
      pinSpacing: false,
      markers: false,
    });
  };

  const initSnap = () => {

    let options = {
      onUp: () => {
        onScrollEnd("down");
      },
      onDown: function () {
        onScrollEnd("up");
      },
    };

    if (isTouchDevice) {
      new onTouchMove(this.element, options);
    } else {
      new Wheel(document.querySelector('[data-scroll-container]'), options);
    }
  };

  const onScrollEnd = (direction) => {
    // let points = this.element.querySelectorAll("[data-snap-point]");

    // currentPosition = points[0].offsetTop;

    let sectionHeight =
      this.element.querySelectorAll("[data-snap-point]")[1].offsetHeight;

    if (direction == "down" && !isScrolling && isStick) {
      if (counter < points.length - 1) {
        isScrolling = true;
        counter++;
        let nextPoint = points[counter];
        let animationPoint = nextPoint.dataset.point;

        console.log('nextPoint.offsetTop', nextPoint.offsetTop)
        console.log('currentPosition', currentPosition)

        let duration = 1000 * ( Math.abs( nextPoint.offsetTop - currentPosition ) / sectionHeight );
        duration = duration || 0;

        // if(points[counter-1].hasAttribute('data-skip')) duration = 1000
        if(nextPoint.hasAttribute('data-duration')) duration = +nextPoint.getAttribute('data-duration')

        console.log('duration', duration)

        this.goToPoint(animationPoint, duration * 0.001, counter, nextPoint, direction, this.forceStart ? 1000 : 0);

        let nextScroll = nextPoint;

        if(counter == points.length - 1 && this.transitionTo) {
          // nextScroll = document.querySelector(this.transitionTo).offsetTop + 5;
        }

        lscroll.scrollTo(nextScroll, {
          duration: duration,
          offset: this.offset,
          callback: () => {
          },
        });

        setTimeout(() => {
          currentPosition = nextPoint.offsetTop;
          isScrolling = false;
        }, duration)

      } else {
        if(window.inTransition) return;
        lscroll.start();
        console.log('lscroll.start')

        isStick = false;
      }
    }

    if (direction == "up" && !isScrolling && isStick) {

      if (counter > 0) {
        isScrolling = true;
        counter--;
        let nextPoint = points[counter];
        let animationPoint = nextPoint.dataset.point;

        console.log('nextPoint.offsetTop', nextPoint.offsetTop)
        console.log('currentPosition', currentPosition)
        console.log('currentPosition', sectionHeight)

        // let nextOffsetTop = nextPoint.hasAttribute('data-skip') ? points[counter-1].offsetTop : nextPoint.offsetTop;

        let duration =
          1000 *
          (Math.abs(nextPoint.offsetTop - currentPosition) / sectionHeight);

        // if(nextPoint.hasAttribute('data-skip')) duration = 1000
        if(nextPoint.hasAttribute('data-duration')) duration = +nextPoint.getAttribute('data-duration')

        console.log('duration', duration)

        this.goToPoint(animationPoint, duration * 0.001, counter, nextPoint, direction, 0);

        let nextScroll = nextPoint;

        if(counter == 0 && this.forceStart) {
          nextScroll = document.querySelector('[data-point-back]');
        }

        setTimeout(() => {
          lscroll.scrollTo(nextScroll, {
            duration: duration,
            offset: this.offset,
            callback: () => {
              // console.log('scrollTo', scrollTo)
              // currentPosition = nextPoint.offsetTop;
              // console.log('after up', this.element)
              // isScrolling = false;
              // console.log('isScrolling', isScrolling)
            },
          });
        }, 0)

        setTimeout(() => {
          currentPosition = nextPoint.offsetTop;
          isScrolling = false;
        }, duration)

      } else {
        if(window.inTransition) return;

        lscroll.start();
        console.log('lscroll.start')

        isStick = false;
      }
    }
  };
}